import { useAdmin } from '@/contexts/AdminContext';
import { cn } from '@/lib/utils';

/**
 * Inline site filter pills for list pages.
 * Usage: <SiteFilter value={siteFilter} onChange={setSiteFilter} />
 */
export default function SiteFilter({ value, onChange, className, exclude = [] }) {
  const { siteAccess, ALL_SITES } = useAdmin();

  const options = [
    { key: 'all', label: 'All Sites' },
    ...ALL_SITES.filter(s => s.key !== 'all' && siteAccess.includes(s.key) && !exclude.includes(s.key)),
  ];

  if (options.length <= 2) return null; // Only 1 site + "All" = no need to filter

  return (
    <div className={cn('flex gap-1.5 flex-wrap', className)}>
      {options.map(s => (
        <button
          key={s.key}
          onClick={() => onChange(s.key)}
          className={cn(
            'text-xs font-medium px-3 py-2 rounded-lg border transition-colors',
            value === s.key
              ? 'bg-stone-900 text-white border-stone-900'
              : 'bg-white text-stone-600 border-stone-200 hover:bg-stone-50'
          )}
        >
          {s.short || s.label}
        </button>
      ))}
    </div>
  );
}
